export default __webpack_public_path__ + "static/media/mdi_error.3e641815.svg";